// ---------------------------------------------------------------------------
// Financeiro › Mapa de Caixa — as CONTAS, lado do front.
//
// ⚠️⚠️ ESTE ARQUIVO É ESPELHO de `server/financeiro/mapa-caixa/mapa-caixa-regras.js`.
//    Ele existe porque o formulário recalcula a Quebra de Caixa e a Diferença
//    GPRS ENQUANTO a pessoa digita, e o front (Create React App) não importa de
//    `server/`. **Mudou um, muda o outro** — a trava é
//    `server/tests/espelhos-back-front.test.js` (PAR do Mapa de Caixa), que
//    compara o COMPORTAMENTO dos dois lados sobre as mesmas entradas.
//
// ⚠️ AUTOCONTIDO de propósito: o carregador do teste roda este arquivo num `vm`
//    do Jest e falha se ele passar a ter `import` ou `export default`.
//
//   quebraCaixa   = totalValorBananas − totalDinheiroFita
//   diferencaGprs = gprsMaquina       − gprsConsolidado
// (a régua da diferença aqui é o CONSOLIDADO, como no papel — ver o servidor.)
// ---------------------------------------------------------------------------

/** Arredonda para centavos — ponto flutuante mente na subtração (1234.56 − 1234.55). */
export function centavos(n) {
    return Math.round(n * 100) / 100;
}

/**
 * As duas contas do mapa.
 * ⚠️ Falta um dos lados → `null`, NUNCA 0: "não preenchido" não pode se parecer
 *    com "conferido e bateu".
 */
export function derivados(valores) {
    const v = valores || {};
    const num = (x) => (x === null || x === undefined || x === '' ? null : Number(x));
    const dif = (a, b) =>
        a === null || b === null || !Number.isFinite(a) || !Number.isFinite(b) ? null : centavos(a - b);

    return {
        quebraCaixa: dif(num(v.totalValorBananas), num(v.totalDinheiroFita)),
        diferencaGprs: dif(num(v.gprsMaquina), num(v.gprsConsolidado)),
    };
}

/**
 * Texto digitado → número, ou `null` quando VAZIO.
 * ⚠️ Vazio e zero são coisas diferentes (ver o servidor). Os três casos que
 *    convivem no campo: '1.234,56' · '1.234' (milhar) · '1234.56' (teclado).
 */
export function normalizarValor(valor) {
    if (valor === null || valor === undefined) return null;
    if (typeof valor === 'number') return Number.isFinite(valor) ? valor : null;
    let s = String(valor).replace(/[^\d.,-]/g, '').trim();
    if (!s) return null;
    if (s.includes(',')) {
        // Tem vírgula → ela é o decimal, e todo ponto é separador de milhar.
        s = s.replace(/\./g, '').replace(',', '.');
    } else if (/^-?\d{1,3}(\.\d{3})+$/.test(s)) {
        // SEM vírgula e com ponto seguido de EXATAMENTE 3 dígitos → milhar.
        // Sem este ramo, '1.234' grava R$ 1,23 e nada acusa.
        s = s.replace(/\./g, '');
    }
    // Qualquer outro ponto ('1234.56', vindo do teclado numérico) é decimal.
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
}
